import secureApi from "../../utils/secureApi";

export interface BadmintonTiePayload {
  tournament: string;
  tournamentSeason: string;
  ageCategory: string;
  eventCategory: string;
  stage: "league" | "knockout";
  side1Team: string;
  side2Team: string;
  date: string;
  time: string;
  venue?: string;
  venueLong?: string;
  knockout?: { stage: string; index: number };
  matches: Array<{ side1Players: string[]; side2Players: string[] }>;
}

const root = "/api/v2/tournaments/admin";
const withSport = (path: string) => `${root}/${path}?sport=Badminton`;
const unwrap = <T,>(response: any): T => (response?.data ?? response) as T;

export interface BadmintonTieFilters {
  tournamentSeason?: string;
  ageCategory?: string;
  eventCategory?: string;
  stage?: "league" | "knockout";
  team?: string;
  page?: number;
  limit?: number;
}

export const listBadmintonTies = (
  tournamentId: string,
  ageCategory: string,
  filters: Omit<BadmintonTieFilters, "ageCategory"> = {}
) =>
  secureApi.get(withSport(`ties/get-all-ties/${tournamentId}`), {
    params: { ageCategory, ...filters },
  });

export const listBadmintonLeagueStandings = (
  tournamentId: string,
  ageCategory: string,
  eventCategory: string
) =>
  secureApi.get("/api/v2/tournaments/website/league-standings", {
    params: {
      sport: "Badminton",
      tournament: tournamentId,
      ageCategory,
      eventCategory,
    },
  });

export const getBadmintonTie = (id: string) => secureApi.get(withSport(`ties/get-by-id/${id}`));

export const createBadmintonTie = (payload: BadmintonTiePayload) =>
  secureApi.post(withSport("ties/add"), payload);

export const updateBadmintonTie = (id: string, payload: Partial<BadmintonTiePayload>) =>
  secureApi.post(withSport(`ties/edit/${id}`), payload);

export const deleteBadmintonTie = (id: string) => secureApi.post(withSport(`ties/delete/${id}`));

export const initializeLeagueStandings = (
  payload: { ageCategoryId: string; eventCategory: string; participants: Array<{ team: string; teamName: string }> }
) => secureApi.post(withSport("league-standings/add"), payload);

export const updateLeagueStanding = (
  payload: { ageCategoryId: string; eventCategory: string; participantId: string; updates: Record<string, number> }
) => secureApi.post(withSport("league-standings/edit"), payload);

export const setLeagueStandings = (
  payload: { ageCategoryId: string; eventCategory: string; standings: Array<Record<string, unknown>> }
) => secureApi.post(withSport("league-standings/set"), payload);

export const unwrapTieResponse = <T,>(response: any): T => unwrap<T>(response);
